import { createApiSlice } from "@common/common-slice/commonSlice";

import {
  MY_PROFILE_DETAILS,
} from "@routes";

const apiConfig = [
  {
    name: "getMyProfileDetail",
    method: "get",
    url: MY_PROFILE_DETAILS,
    stateKey: "myProfileDetailData",
  },
];

const customReducers = {
  initialState: {
    myProfileDetailData: [],
    selectedData: {},
  },

  reducers: {
  },

  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "organization",
  apiConfig,
  customReducers,
);

const myProfile = slice;

export default myProfile.reducer;

export const actionsExports = actions;

export const {
  getMyProfileDetail,
} = thunks;

export const { rowSelect } =
  actionsExports;
